const V2_CONTROLLER_METHODS = Object.freeze([
  'startProduction',
  'startRepetition',
  'finishRepetition',
  'finishProduction',
  'pause',
  'resume',
  'updateConfig',
  'cancel',
  'restore',
]);

export const assertV2MonitorController = (controller) => {
  if (!controller || typeof controller !== 'object') {
    throw new TypeError('V2 monitor controller must be an object');
  }

  const missingMethods = V2_CONTROLLER_METHODS.filter(
    (method) => typeof controller[method] !== 'function',
  );

  if (missingMethods.length) {
    throw new TypeError(`V2 monitor controller is missing: ${missingMethods.join(', ')}`);
  }

  return controller;
};